export enum CommonActionTypes {
    LOAD_USERPROFILE_SUCCESS = "LOAD_USERPROFILE_SUCCESS",
    INVALIDATE_COMPANY_LOGO = "INVALIDATE_COMPANY_LOGO",
    LOAD_USER_SETTINGS_SUCCESS = "LOAD_USER_SETTINGS_SUCCESS",
    GET_UNREAD_APPROVALS_COUNT_SUCCESS = "GET_UNREAD_APPROVALS_COUNT_SUCCESS",
    SET_NEW_CURRENT_USERNAME = "SET_NEW_CURRENT_USERNAME",
    UPDATE_AVATARS_VERSION = "UPDATE_AVATARS_VERSION",
    SET_NEW_USERNAME = "SET_NEW_USERNAME",
}
